const FEATURE_FLAGS = {
  articleCardList: 'articleCardList',
  brandHeader: 'brandHeader',
  brandTitleBar: 'brandTitleBar',
  comments: 'comments',
  containedSearch: 'containedSearch',
  header: 'header',
  infoCardList: 'infoCardList',
  likeButton: 'likeButton',
  mediaCardList: 'mediaCardList',
  newsletterSubscription: 'newsletterSubscription',
  recommendationList: 'recommendationList',
  popularRecommendationList: 'popularRecommendationList',
  popularByBrandRecommendationList: 'popularByBrandRecommendationList',
  relatedByThemeRecommendationList: 'relatedByThemeRecommendationList',
  sterBanner: 'sterBanner',
  subNavigation: 'subNavigation',
  themeSubNavigation: 'themeSubNavigation',
  topBar: 'topBar',
  brandNavigation: 'brandNavigation',
};

export default FEATURE_FLAGS;
